// Tracking GTM + Segment
export const CALENDAR_DATE_SELECTED = 'Date Selected'
export const DATE_TIME_SELECTED = 'Date & Time Selected'
export const TIMESLOT_SELECTED = 'Time Selected'
export const TICKETS_SELECTED = 'Tickets Selected'
export const PRODUCT_ADDED = 'Product Added'
export const PRODUCT_REMOVED = 'Product Removed'
export const GIFT_ADDED = 'Gift Order Selected'
export const GIFT_REMOVED = 'Gift Order Unselected'
export const GIFTEE_ADDED = 'Giftee Info Added'
export const CHECKOUT = 'Checkout'
export const CHECKOUT_STARTED = 'Checkout Started'
export const PURCHASE_CONFIRMATION = 'Purchase Confirmation'
export const ORDER_COMPLETED = 'Order Completed'
export const PRODUCT_VIEWED = 'Product Viewed'
export const PAYMENT_INFO_ENTERED = 'Payment Info Entered'
export const ADMISSION_TYPE_SELECTED = 'Admission Type Selected'
export const SELLER_CHANGED = 'Seller Changed'
export const TICKET_DESCRIPTION_OPENED = 'Ticket Description Opened'
export const PORTAL_PASS_MODAL_OPENED = 'Portal Pass Modal Opened'
export const PORTAL_PASS_MODAL_REDIRECT = 'User Redirected to Portal Pass Purchase Flow'
export const PORTAL_PASS_BANNER_VIEWED = 'Portal Pass Banner Viewed'
export const PORTAL_PASS_BANNER_CLICKED = 'Portal Pass Banner Clicked'
/** Amplitude Experiment's exposure event; its name is fixed by Amplitude. */
export const EXPERIMENT_EXPOSURE = '$exposure'
export const MW_SID = 'rtl-sid'
export const MW_ANON_ID = 'anonymousId'
export const SEGMENT_ANON_ID = 'segmentAnonId'
export const SEGMENT_USER_TIMEOUT_MS = 500
/** Share of Zaraz consent fallbacks sent to Sentry, so visitors who block Zaraz can't use up the quota. */
export const ZARAZ_UNAVAILABLE_SENTRY_SAMPLE_RATE = 0.1
